import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../layout/Header';
import ContenedorMapHome from './ContenedorMapHome'; 
import CarruselImagenHome from './CarruselImagenHome';
import PublicidadHome from './PublicidadHome';
import ContendorCategoryDestinosHome from './ContendorCategoryDestinosHome';
import ModalInicioHome from './ModalInicioHome';
import Footer from "../../layout/Footer";
import WhatsAppButton from './WhatsAppButton';
import ChatBotButton from '../ChatBot/ChatBotButton';
import InformacionPage from '../pages/informacion/index';

const Home = () => {
    const { id } = useParams(); // 👈 lee el ID si existe

    return (
        <>
            <Header />

            {/* HOME NORMAL */}
            {!id && (
                <>
                    <ModalInicioHome />
                    <PublicidadHome/>
                    <ContenedorMapHome /> 
                    <CarruselImagenHome />
                    <ContendorCategoryDestinosHome/>
                    <WhatsAppButton />
                    {/* <ChatBotButton /> */}
                </>
            )}

            {/* DETALLE POR ID */}
            {id && <InformacionPage />}

            <Footer/>
        </>
    );
};

export default Home;
